import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SSButton } from "./SSButton";
import { waLink } from "@/data/site";
import { ContourField } from "./ContourField";

/**
 * ContextualCTA — a conversion band tuned to the content it follows.
 * Never "CONTACT US NOW"; always contextual.
 */
export const ContextualCTA = ({
  eyebrow = "Advisory",
  title,
  text,
  primaryLabel = "Request an assessment",
  primaryTo = "/advisory",
  whatsappMessage,
  tone = "dark",
}) => {
  const dark = tone === "dark";
  return (
    <section className="ss-container my-20 lg:my-28" data-testid="contextual-cta">
      <div
        className={`relative overflow-hidden ${
          dark ? "bg-[#2D3B32] text-[#F7F5F0]" : "bg-[#EFECE6] text-[#1A1C1E]"
        } px-7 py-12 sm:px-14 sm:py-16`}
      >
        <ContourField
          className="absolute right-0 top-0 h-full w-1/2 opacity-[0.1]"
          stroke={dark ? "#F7F5F0" : "#2D3B32"}
          opacity={0.6}
        />
        <div className="relative max-w-2xl">
          <p className={`ss-overline mb-5 ${dark ? "text-[#C2A374]" : "text-[#8C6A53]"}`}>{eyebrow}</p>
          <h2 className={`font-display text-3xl sm:text-4xl font-light leading-tight ${dark ? "text-[#F7F5F0]" : "text-[#1A1C1E]"}`}>
            {title}
          </h2>
          {text && <p className={`mt-4 text-base sm:text-lg font-light ${dark ? "text-[#F7F5F0]/75" : "text-[#52575D]"}`}>{text}</p>}
          <div className="mt-8 flex flex-wrap items-center gap-4">
            <SSButton to={primaryTo} variant={dark ? "light" : "primary"} data-testid="cta-primary">
              {primaryLabel}
            </SSButton>
            <a
              href={waLink(whatsappMessage)}
              target="_blank"
              rel="noopener noreferrer"
              className={`group inline-flex items-center gap-1.5 text-sm tracking-[0.04em] ${dark ? "text-[#F7F5F0]/80" : "text-[#1A1C1E]"}`}
              data-testid="cta-whatsapp"
            >
              <span className="ss-link">Discuss on WhatsApp</span>
              <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.5} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContextualCTA;
